import { validateTestCodeAPI } from 'api/client';
import { CLIENT_API_FEVER_HOST } from 'config/envVariable';
import { IS_OFFLINE } from 'config/promoOnlineStatus';
import * as clientErrTypes from 'config/clientErrorTypes';
import { generateApiErrObj } from 'client/hooks/useClientErrorHandler';

import useRemoveAndRetrieveQs from 'hooks/useRemoveAndRetrieveQs';

export function useRemoveUnnecessaryQueryStr() {
    const qsHandler = useRemoveAndRetrieveQs();
    return state => {
        const {
            promo: { status: promoStatus }
        } = state;
        let shouldRemoveQsKey = ['tryliff'];
        if (promoStatus !== IS_OFFLINE) {
            shouldRemoveQsKey.push('test_code', 'test_expired');
        }
        return qsHandler(shouldRemoveQsKey);
    };
}
export async function validateTestCode(state, { test_code, test_expired } = {}) {
    const {
        sponsor: { id: sponsorId }
    } = state;

    if (Boolean(sponsorId) && Boolean(test_code) && Boolean(test_expired)) {
        const validateResp = await validateTestCodeAPI({
            host: CLIENT_API_FEVER_HOST,
            sponsorId,
            testCode: test_code,
            testExpired: test_expired
        });
        const { httpStatus, payload } = validateResp;
        if (httpStatus !== 200) {
            throw generateApiErrObj(validateResp);
        } else if ((payload ?? [])[0] !== true) {
            throw generateApiErrObj(validateResp, clientErrTypes.INVALID_TEST_CODE);
        }
    }
}
